/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    DistributedRewardResponse,
    DistributedRewardResponseFromJSON,
    DistributedRewardResponseFromJSONTyped,
    DistributedRewardResponseToJSON,
} from './';

/**
 * 
 * @export
 * @interface GetDistributedRewardsOwnResponse
 */
export interface GetDistributedRewardsOwnResponse {
    /**
     * 
     * @type {Array<DistributedRewardResponse>}
     * @memberof GetDistributedRewardsOwnResponse
     */
    rewards: Array<DistributedRewardResponse>;
}

export function GetDistributedRewardsOwnResponseFromJSON(json: any): GetDistributedRewardsOwnResponse {
    return GetDistributedRewardsOwnResponseFromJSONTyped(json, false);
}

export function GetDistributedRewardsOwnResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetDistributedRewardsOwnResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'rewards': ((json['rewards'] as Array<any>).map(DistributedRewardResponseFromJSON)),
    };
}

export function GetDistributedRewardsOwnResponseToJSON(value?: GetDistributedRewardsOwnResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'rewards': ((value.rewards as Array<any>).map(DistributedRewardResponseToJSON)),
    };
}


